if (!customElements.get('section-product')) {
  class TG_SectionProduct extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.element = this;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
  
      this.productVariants = new themegoal.components_business.product_variants.ProductVariants(this.element, this.options);

      this.mediaIdIndexs = null;
      if(this.element.querySelector('[data-product-media-id-index-json]')){
        let productMediaJsonData = JSON.parse(this.element.querySelector('[data-product-media-id-index-json]').innerHTML);
        this.mediaIdIndexs = productMediaJsonData['media_id_index'];
      }
    
      let productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
      let productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');

      if (productSlideshowNavElement) {
        this.productSlideshowNav = new themegoal.components.Carousel(productSlideshowNavElement);
      }
  
      if (productSlideshowElement) {
        this.productSlideshow = new themegoal.components.Carousel(productSlideshowElement);
      }
  
      if (this.options['enableImageZoom']) {
        this.imageZoomInstance = new themegoal.components_business.product_variants.ProductImageModal(this.element, this.options);
      }
  
      let styleWithCarouselEle = this.element.querySelectorAll(".ProductStyleWith__Body .ProductList--carousel");
  
      this.styleWithCarousels = [];
      if (styleWithCarouselEle){
        let _this = this;
        styleWithCarouselEle.forEach(function (ele) {
          _this.styleWithCarousels.push(new themegoal.components.Carousel(ele));
        });
      }
  
      let offscreenElements = this.element.querySelectorAll('.Site__TopLevelElment');
  
      if (offscreenElements) {
        offscreenElements.forEach(function (ele) {
          document.body.appendChild(ele);
          // ele.parentNode.removeChild(ele);
        });
      }
  
      this.blockRecommendationsElementRelated = this.element.querySelector('.ProductBlockRecommendations--related');
  
      if (this.blockRecommendationsElementRelated) {
        this._loadRecommendations();
      }
  
      this.blockRecommendationsElementComplementary = this.element.querySelector('.ProductBlockRecommendations--complementary');
  
      if (this.blockRecommendationsElementComplementary) {
        this._loadRecommendationsComplementary();
      }
  
      this._bindEventsListeners();
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
      if(this.productSlideshow)this.productSlideshow.destroy();
      if(this.productSlideshowNav)this.productSlideshowNav.destroy();
      if(this.styleWithCarousels){
        this.styleWithCarousels.forEach(function (carousel) {
          carousel.destroy();
        });
      }
    }
  
    _bindEventsListeners() {
      this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));

      let isQuickViewDrawer = this.closest('[data-quick-view-drawer-content]');

        let updateStickyAtc = true;
        if(isQuickViewDrawer){
          updateStickyAtc = false;
        }

        if(updateStickyAtc) {
          this.delegateElement.on('variant:changed', this._updateStickAddToCartVariant.bind(this));
        }
      
    }

    _updateStickAddToCartVariant(event){
      let variant = event.detail.variant;
      let previousVariant = event.detail.previousVariant;
      let productCardHorizontalElement = this.element.querySelector('.ProductStickyAddToCart');
      
      if(variant.available){
        let productCardHorizontalVariantTitleElement = this.element.querySelector('.ProductCardHorizontal__VariantTitle');

        if(productCardHorizontalVariantTitleElement){
          productCardHorizontalVariantTitleElement.innerHTML = variant.title;
        }

        // if(productCardHorizontalElement.classList.contains("ProductStickyAddToCart--hidden")){
        //   productCardHorizontalElement.classList.remove("ProductStickyAddToCart--hidden");
        // }


        if(document.querySelectorAll('[data-action="sticky-add-to-cart"]')) {

            document.querySelectorAll('[data-action="sticky-add-to-cart"]').forEach(button => {
               button.innerHTML = `<span>${button.dataset.atcText}</span>`;
            button.removeAttribute("disabled");
            button.classList.add("Button--primary");
            button.classList.remove("Button--secondary");
             })

          

        }
   

      }else{

        if(document.querySelectorAll('[data-action="sticky-add-to-cart"]')) {

         
        
          document.querySelectorAll('[data-action="sticky-add-to-cart"]').forEach(button => {
        
            button.innerHTML = `<span>${button.dataset.soldoutText}</span>`;
            button.setAttribute("disabled", "disabled");
            button.classList.remove("Button--primary");
            button.classList.add("Button--secondary");

        });
        }
     
       // productCardHorizontalElement.classList.add("ProductStickyAddToCart--hidden");
      }

      let productCardHorizontalIdElement = this.element.querySelector('.ProductStickyAddToCart input[name="id"]');
      productCardHorizontalIdElement.setAttribute("value", variant.id);


      let productCardHorizontalIdOptionElements = this.element.querySelectorAll('.ProductStickyAddToCart [data-option="option1"]');

     
      if(productCardHorizontalIdOptionElements) {
        productCardHorizontalIdOptionElements.forEach(productCardHorizontalIdOptionElement => {

          productCardHorizontalIdOptionElement.value = variant.option1;
          
        })
        
      }
    

      if (!variant || !variant['featured_image'] || previousVariant && previousVariant['featured_image'] && previousVariant['featured_image']['id'] === variant['featured_image']['id']) {
        return;
      }
  
      let newImage = variant['featured_image'];
      let mainImageContainer = productCardHorizontalElement.querySelector('.ProductCardHorizontal__ImageWrapper');
  
      let newImageElement = document.createElement('img');
      newImageElement.setAttribute('src', newImage['src']);
      mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector('img'));

    }
  
    _loadRecommendations() {
      var _this = this;
  
      var url = window.routes.productRecommendationsUrl + '?section_id=product-block-recommendations&intent=related&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsRelatedCount'];
  
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;
  
          let recommendationsElement = _this.element.querySelector('.ProductBlockRecommendations--related .ProductBlockRecommendations__Body');
          
          if(container.querySelector('.Carousel__Item')){
            recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".ProductBlockRecommendations__Body").innerHTML;
            new themegoal.components.Carousel(recommendationsElement.querySelector('[data-carousel-config]'));
  
          }else{
            _this.blockRecommendationsElementRelated.style.display = 'none';
          }
  
        });
      });
    }
  
    _loadRecommendationsComplementary() {
      var _this = this;
  
      var url = window.routes.productRecommendationsUrl + '?section_id=product-block-recommendations&intent=complementary&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsComplementaryCount'];
  
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;
  
          let recommendationsElement = _this.element.querySelector('.ProductBlockRecommendations--complementary .ProductBlockRecommendations__Body');
          
          if(container.querySelector('.Carousel__Item')){
            recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".ProductBlockRecommendations__Body").innerHTML;
            new themegoal.components.Carousel(recommendationsElement.querySelector('[data-carousel-config]'));
  
          }else{
            _this.blockRecommendationsElementComplementary.style.display = 'none';
          }
  
        });
      });
    }
  
    _updateSlideshowImage(event) {
      var _this = this;
      var variant = event.detail.variant,
          previousVariant = event.detail.previousVariant;
  
      if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
        return;
      }
  
      let variantFeaturedMediaId = variant['featured_media']['id'];

      if (this.options['galleryDesign'] == 'carousel' && this.productSlideshow) {
        if(this.options["enableMediaGrouping"]&&previousVariant.options[0]!=variant.options[0]){
          this.mediaIdIndexs = null;
          if(this.element.querySelector('[data-product-media-id-index-json]')){
            let productMediaJsonData = JSON.parse(this.element.querySelector('[data-product-media-id-index-json]').innerHTML);
            this.mediaIdIndexs = productMediaJsonData['media_id_index'];
          }
          this.productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');
          this.productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
          
          if (this.productSlideshowNavElement) {
            this.productSlideshowNav = new themegoal.components.Carousel(this.productSlideshowNavElement);
          }

          if (this.productSlideshowElement) {
            this.productSlideshow = new themegoal.components.Carousel(this.productSlideshowElement);
          }
        }
        
        if (this.mediaIdIndexs && this.mediaIdIndexs.hasOwnProperty("id_" + variantFeaturedMediaId)){
          this.productSlideshow.selectCell(this.mediaIdIndexs["id_" + variantFeaturedMediaId]);
        }

        let carouselEle = _this.productSlideshow.carouselInstance.el.querySelectorAll(".Carousel__Item");
          carouselEle.forEach(function (ele) {
            ele.classList.remove("Carousel__Item--currentItem");
          });

        setTimeout(function () {
          let carouselEle = _this.productSlideshow.carouselInstance.el.querySelectorAll(".Carousel__Item");
          carouselEle.forEach(function (ele) {
            if(ele.classList.contains("Carousel__Item--active") && !ele.classList.contains("Carousel__Item--currentItem"))
            ele.classList.add("Carousel__Item--currentItem"); 
          });
        }, 800);
      } 
    
    }
    
  }
    
  customElements.define('section-product', TG_SectionProduct);
}
